import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const Hero = ({
  classNames,
  backgroundColor,
  backgroundImageInMobile,
  content,
  dataScroll,
  iconGooglePlayStore,
  iconAppleAppStore,
  productIcon,
  productName,
  children,
  customHeading,
  customButtons,
}) => {
  const AppIcon = ({ imgSrc }) => (
    <li className="list-inline-item mx-3">
      <a
        href={"https://zipmex.onelink.me/8NSq/15940e3a"}
        target="_blank"
        rel="noreferrer noopener"
      >
        <img src={imgSrc} alt="" />
      </a>
    </li>
  );

  return (
    <>
      <div
        className={cx(
          "hero mt-auto",
          classNames,
          `bg-color-${backgroundColor}`,
          { "hide-bg-mobile": !backgroundImageInMobile }
        )}
      >
        <div className="container">
          {content.edges.map((post, i) => (
            <div className="row" key={i}>
              <div className="hero-content col-12 col-lg-7">
                <div>
                  {productName && (
                    <div className="d-flex align-items-center mb-4">
                      <img
                        src={productIcon.publicURL}
                        alt=""
                        loading="eager"
                        width={40}
                        height={40}
                      />
                      <span
                        className="ml-3"
                        style={{
                          fontWeight: 700,
                          fontSize: "1.5rem",
                        }}
                      >
                        {productName}
                      </span>
                    </div>
                  )}
                  {customHeading ? (
                    customHeading
                  ) : (
                    <h1
                      dangerouslySetInnerHTML={{
                        __html: post.node.acfHeroSections.hsMainHeading,
                      }}
                      {...dataScroll}
                    />
                  )}
                  <div
                    className="main-content"
                    dangerouslySetInnerHTML={{
                      __html: post.node.acfHeroSections.hsMainText,
                    }}
                    {...dataScroll}
                  />
                  <ul className="list-inline" {...dataScroll}>
                    {post.node.acfHeroSections.hsButtonLink && (
                      <li className="list-inline-item mr-3">
                        <a
                          className={`button button-primary${
                            backgroundColor === "lime" ? "-lime" : ""
                          }`}
                          href={post.node.acfHeroSections.hsButtonLink}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          {post.node.acfHeroSections.hsButtonText}
                        </a>
                      </li>
                    )}
                    {iconGooglePlayStore && (
                      <AppIcon imgSrc={iconGooglePlayStore.publicURL} />
                    )}
                    {iconAppleAppStore && (
                      <AppIcon imgSrc={iconAppleAppStore.publicURL} />
                    )}
                    {customButtons}
                  </ul>
                </div>
              </div>
              <div
                className={cx("col hero-image w-100 h-auto d-none d-lg-block", {
                  "text-center align-self-end": children,
                })}
              >
                {children}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

Hero.propTypes = {
  classNames: PropTypes.string,
  backgroundColor: PropTypes.oneOf(["blue", "lime"]),
  backgroundImageInMobile: PropTypes.bool,
  content: PropTypes.any,
  dataScroll: PropTypes.any,
  iconGooglePlayStore: PropTypes.any,
  iconAppleAppStore: PropTypes.any,
  productIcon: PropTypes.any,
  productName: PropTypes.string,
  customHeading: PropTypes.node,
  customButtons: PropTypes.node,
};

export default Hero;
